export default "__VITE_ASSET__0fSJpR9c__"